import { render } from "./BehaviorEvents.vue?vue&type=template&id=10180712&scoped=true"
import script from "./BehaviorEvents.vue?vue&type=script&lang=js"
export * from "./BehaviorEvents.vue?vue&type=script&lang=js"

import "./BehaviorEvents.vue?vue&type=style&index=0&id=10180712&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10180712"]])

export default __exports__